import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyLegalInfo = lazy(() => import('./LegalInfo'));

export const LegalInfo: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyLegalInfo {...props} />
	</Suspense>
);
